"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _CartObserver_data, _CartObserver_subscribers;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartObserver = void 0;
const error_handler_1 = require("./error-handler");
const http_client_1 = require("./http-client");
class CartObserver {
    constructor() {
        _CartObserver_data.set(this, void 0);
        _CartObserver_subscribers.set(this, []);
    }
    update(initiator, data = null) {
        if (data === null) {
            return http_client_1.httpClient.get('/_cart/cart/get').then((response) => {
                __classPrivateFieldGet(this, _CartObserver_subscribers, "f").forEach((subscriber) => subscriber(response.data, initiator));
                __classPrivateFieldSet(this, _CartObserver_data, response.data, "f");
            }).catch(error_handler_1.handleAjaxError);
        }
        return new Promise((resolve) => {
            __classPrivateFieldGet(this, _CartObserver_subscribers, "f").forEach((subscriber) => subscriber(data, initiator));
            __classPrivateFieldSet(this, _CartObserver_data, data, "f");
            resolve();
        });
    }
    subscribe(callback) {
        __classPrivateFieldGet(this, _CartObserver_subscribers, "f").push(callback);
    }
    showCart() {
        document.body.classList.add('show-cart');
    }
}
_CartObserver_data = new WeakMap(), _CartObserver_subscribers = new WeakMap();
// @ts-ignore
window.cartObserver = window.cartObserver || new CartObserver();
// @ts-ignore
exports.cartObserver = window.cartObserver;
